export default __webpack_public_path__ + "static/media/myprofile.d4dd5735.png";